<template>
  <div
    id="main"
    ref="main"
    @mousemove="onMouseMove"
    class="is-full u-full-width u-relative u-overflow-hidden u-antialiased"
  >
    <div ref="containerWebGL" class="u-wrapper-panel"/>
    
    <frame-by-frame />

    <div ref="containerCSS3D" class="u-wrapper-panel u-overflow-hidden"/>
  </div>
</template>

<script>
import App from './App'

import SymbolsSvg from '@/components/SymbolsSvg'
import data from '@/assets/data'
// import FrameByFrame from '@/components/FrameByFrame'
import FrameByFrame from '@/components/FrameByFrame60'

export default {
  name: 'App',

  mixins: [App],

  components: {
    SymbolsSvg,
    FrameByFrame
  },

}
</script>

<style lang="stylus" src="./styles/theme.styl"/>

<style lang="stylus">
// @import '~@/styles/settings/variables'

#main
  min-height 100vh

  &.is-full
    position fixed
    top .2px
    bottom .2px
    left 0
    right 0
    overflow hidden
    min-height auto

</style>